import { render, staticRenderFns } from "./CommonRankNumber.vue?vue&type=template&id=9a996ddc&scoped=true"
import script from "./CommonRankNumber.vue?vue&type=script&lang=ts"
export * from "./CommonRankNumber.vue?vue&type=script&lang=ts"
import style0 from "./CommonRankNumber.vue?vue&type=style&index=0&id=9a996ddc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a996ddc",
  null
  
)

export default component.exports